export default {
  title: "RH Restaurants Main",
  type: "rh/components/content/rh-restaurants-v2",
  isContainer: false,
  config: {
    emptyLabel: "RH Restaurants Main",
    isEmpty: () => false
  }
};
